import Enum from '../interfaces/IEnum';

export const EditionType: Enum = {
    enum: {
        APPLICANTINSCRIPTION: 0,
        ADMININSCRIPTION: 1,
        APPLICANTCORRECTION: 2
    }
};
